import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useApolloClient, gql, useReactiveVar } from '@apollo/client';
import { useEffect, useState } from 'react';
// import { withfriendsMixpanel as mixpanel } from '../helpers/mixpanel'
import { calculateTiers } from '../helpers/calculator';
import { writeMembershipTier } from '../cache/transformers';
import { membershipsHaveBeenEditedVar, currentShopifyVersionVar, primaryActionLoadingVar } from "../helpers/client";
import { majorToMinorPrice, minorToMajorPrice } from '../helpers/tools';
import { dummyFunc } from '../helpers/client';
import { useChooseYourFighterQuery, useCollectionNamesQuery, PlanKind, DiscountScope, usePollImportCompletedQuery, useUpdateMembershipMutation, } from '../types';
import Button, { ButtonVariant } from './Button';
import MembershipLevel from './MembershipLevel';
import { MembershipLevelPosition } from '../helpers/helpText';
import LoadingScreen from './LoadingScreen';
import ErrorScreen from './ErrorScreen';
import NotFoundScreen from './NotFoundScreen';
import { GiFairyWand } from "react-icons/gi";
export const PrimaryAction = "Choose Your Fighter";
export var ChooseYourFighterAction;
(function (ChooseYourFighterAction) {
    ChooseYourFighterAction["AddedMembershipLevel"] = "Added Membership Tier";
})(ChooseYourFighterAction || (ChooseYourFighterAction = {}));
gql `
query ChooseYourFighter($id: ID!) {
  business(id: $id) {
    id
    status
    shopifyVersion
    membershipTiers(kind:Live) {
      id
      defaultMode
      plans {
        kind
        price {
          amount
        }
      }
      discounts {
        scope
        percentage
        guests
      }
    }
  }
}
`;
gql `
query CollectionNames($id: ID!){
  business(id: $id) {
    id
    shopifyCollectionNames
  }
}
`;
const ChooseYourFighter = ({ aov, cvf, businessId, extraButtons, useSyncShopifyDataMutation = dummyFunc }) => {
    var _a, _b, _c, _d, _e;
    const client = useApolloClient();
    const membershipsHaveBeenEdited = useReactiveVar(membershipsHaveBeenEditedVar);
    const [currentTiersMatchCalculatedTiers, setCurrentTiersMatchCalculatedTiers] = useState(false);
    const currentShopifyVersion = useReactiveVar(currentShopifyVersionVar);
    const primaryActionLoading = useReactiveVar(primaryActionLoadingVar);
    const [strategy, setStrategy] = useState(3);
    const [collections, setCollections] = useState([]);
    const STRATEGIES = [0.1, 1.0];
    const [newTiers, setNewTiers] = useState([]);
    const [syncToShopify] = useSyncShopifyDataMutation({
        variables: {
            id: businessId
        },
        skip: !businessId,
    });
    const [addTier] = useUpdateMembershipMutation({
        variables: {
            id: businessId,
            membershipInput: {},
        },
        update: async (cache, response) => {
            var _a;
            const membershipTierCreate = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.updateOrCreateMembership;
            cache.modify({
                id: `Business:${businessId}`,
                fields: {
                    membershipTiers: (existingMembershipTierRefs = [], { readField }) => {
                        if (!existingMembershipTierRefs) {
                            existingMembershipTierRefs = [];
                        }
                        // KGAUDIT - is this a poor man's toReference?
                        const newMembershipTierRef = { __ref: `MembershipTier:${membershipTierCreate.id}` };
                        if (existingMembershipTierRefs.some(ref => readField('id', ref) === membershipTierCreate.id)) {
                            return existingMembershipTierRefs;
                        }
                        return [...existingMembershipTierRefs, newMembershipTierRef];
                    }
                }
            });
            await syncToShopify();
            primaryActionLoadingVar(false);
        },
    });
    const { data, loading, error } = useChooseYourFighterQuery({
        variables: { id: businessId },
    });
    const { data: dataV2 } = useCollectionNamesQuery((data === null || data === void 0 ? void 0 : data.business.shopifyVersion) == 2 ? { variables: { id: businessId } } : null);
    const { data: importDataV2, stopPolling: stopPollingImportDataV2 } = usePollImportCompletedQuery((currentShopifyVersion == 2) ? { variables: { id: businessId }, skip: !businessId || primaryActionLoading, pollInterval: 5000 } : null);
    useEffect(() => {
        var _a, _b, _c;
        if ((_b = (_a = dataV2 === null || dataV2 === void 0 ? void 0 : dataV2.business) === null || _a === void 0 ? void 0 : _a.shopifyCollectionNames) === null || _b === void 0 ? void 0 : _b.length) {
            setCollections((_c = dataV2 === null || dataV2 === void 0 ? void 0 : dataV2.business) === null || _c === void 0 ? void 0 : _c.shopifyCollectionNames.filter(c => c != "Home page"));
        }
    }, [(_a = dataV2 === null || dataV2 === void 0 ? void 0 : dataV2.business) === null || _a === void 0 ? void 0 : _a.shopifyCollectionNames]);
    useEffect(() => {
        var _a, _b, _c, _d;
        if ((_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.membershipTiers) {
            if (!data.business.membershipTiers.some(x => !x.defaultMode) && ((_b = data === null || data === void 0 ? void 0 : data.business) === null || _b === void 0 ? void 0 : _b.status) == "Approved") {
                // setNewStrategy(data.business.membershipTiers)
                //TODO = I don't know why this is needed exactly but if I don't do it, I can't edit the prices
                setNewTiers((_c = data === null || data === void 0 ? void 0 : data.business) === null || _c === void 0 ? void 0 : _c.membershipTiers.map(tier => { var _a, _b, _c, _d, _e; return { price: (_c = (_b = (_a = tier.plans) === null || _a === void 0 ? void 0 : _a.find(t => t.kind == "MONTHLY")) === null || _b === void 0 ? void 0 : _b.price) === null || _c === void 0 ? void 0 : _c.amount, discount: (_e = (_d = tier.discounts) === null || _d === void 0 ? void 0 : _d.find(d => d.scope == "RETAIL")) === null || _e === void 0 ? void 0 : _e.percentage }; }));
            }
            else {
                membershipsHaveBeenEditedVar(true);
                //TODO = I don't know why this is needed exactly but if I don't do it, I can't edit the prices
                setNewTiers((_d = data === null || data === void 0 ? void 0 : data.business) === null || _d === void 0 ? void 0 : _d.membershipTiers.map(tier => { var _a, _b, _c, _d, _e; return { price: (_c = (_b = (_a = tier.plans) === null || _a === void 0 ? void 0 : _a.find(t => t.kind == "MONTHLY")) === null || _b === void 0 ? void 0 : _b.price) === null || _c === void 0 ? void 0 : _c.amount, discount: (_e = (_d = tier.discounts) === null || _d === void 0 ? void 0 : _d.find(d => d.scope == "RETAIL")) === null || _e === void 0 ? void 0 : _e.percentage }; }));
            }
        }
    }, [(_b = data === null || data === void 0 ? void 0 : data.business) === null || _b === void 0 ? void 0 : _b.id]);
    useEffect(() => {
        var _a, _b, _c;
        if ((_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.membershipTiers) {
            const currentTiers = (_c = (_b = data === null || data === void 0 ? void 0 : data.business) === null || _b === void 0 ? void 0 : _b.membershipTiers.map(tier => {
                var _a, _b, _c;
                return {
                    price: (_b = (_a = tier.plans.find(plan => plan.kind === PlanKind.Monthly)) === null || _a === void 0 ? void 0 : _a.price) === null || _b === void 0 ? void 0 : _b.amount,
                    discount: (_c = tier.discounts.find(discount => discount.scope === DiscountScope.Retail)) === null || _c === void 0 ? void 0 : _c.percentage,
                };
            })) === null || _c === void 0 ? void 0 : _c.sort((a, b) => a.price - b.price);
            console.log(currentTiers);
            console.log(newTiers);
            setCurrentTiersMatchCalculatedTiers(currentTiers.every((tier, i) => { var _a, _b; return tier.price === ((_a = newTiers[i]) === null || _a === void 0 ? void 0 : _a.price) && tier.discount === ((_b = newTiers[i]) === null || _b === void 0 ? void 0 : _b.discount); }));
        }
    }, [(_c = data === null || data === void 0 ? void 0 : data.business) === null || _c === void 0 ? void 0 : _c.membershipTiers]);
    useEffect(() => {
        var _a, _b;
        if (((_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.status) == "Approved" && ((_b = data === null || data === void 0 ? void 0 : data.business) === null || _b === void 0 ? void 0 : _b.membershipTiers) && !membershipsHaveBeenEdited && !data.business.membershipTiers.some(x => !x.defaultMode)) {
            // setNewStrategy(data.business.membershipTiers)
        }
    }, [aov, cvf]);
    if (loading) {
        return _jsx(LoadingScreen, {});
    }
    if (error) {
        return _jsx(ErrorScreen, { message: error.message });
    }
    if (!(data === null || data === void 0 ? void 0 : data.business)) {
        return _jsx(NotFoundScreen, {});
    }
    const setNewStrategy = async (tiers) => {
        if (!tiers || tiers.length < 3) {
            setNewTiers([]);
            return;
        }
        let idx = strategy;
        // mixpanel.track("Membership Tiers", {action: "Set Membership Strategy"})
        let sub = false;
        if (idx === 3) {
            sub = true;
            idx = 2;
        }
        const currentTiers = calculateTiers(aov, cvf, STRATEGIES[idx - 1]);
        currentTiers.forEach(tier => { tier.price = majorToMinorPrice(Math.round(minorToMajorPrice(tier.price))); });
        if (sub)
            currentTiers[2].discount = currentTiers[1].discount;
        setNewTiers(currentTiers);
        tiers.slice(0, 3).map((tier, idx) => {
            // if (tier.defaultMode) {
            writeMembershipTier(tier.id, currentTiers[idx], client);
            // }
        });
        membershipsHaveBeenEditedVar(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx("h2", { className: "text-4xl font-light max-w-xl w-full mb-4", style: { textAlign: "center" }, children: (membershipsHaveBeenEdited && !currentTiersMatchCalculatedTiers || data.business.status == "Live") ? (_jsx(_Fragment, { children: "Your Membership Tiers." })) : (_jsx(_Fragment, { children: "Your Membership Tier Recommendations." })) }), _jsxs("div", { children: [(currentShopifyVersion == 2 && !!importDataV2 && !((_d = importDataV2.business) === null || _d === void 0 ? void 0 : _d.importAnalytics)) ? (_jsxs("div", { className: "w-full flex flex-wrap justify-center font-heavy mb-4 text-salmon-600 animate animate-pulse", children: ["We're still loading your customer data...", _jsx("br", {}), "Our recommendations will periodically update as we process your data."] })) : (_jsx("div", { className: "font-heavy mb-4 text-salmon-600" })), data.business.status == "Approved" && (_jsx("div", { className: "w-full justify-center flex", children: _jsx("div", { className: "max-w-xl prose lg:prose-lg", children: _jsxs("p", { className: "max-w-none border-b-2 border-wfGray-600 pb-4 mb-4", children: [(membershipsHaveBeenEdited && !currentTiersMatchCalculatedTiers) ? (_jsx(_Fragment, { children: "Customize anything you'd like below." })) : (_jsxs(_Fragment, { children: [((primaryActionLoading && !importDataV2) || !!((_e = importDataV2 === null || importDataV2 === void 0 ? void 0 : importDataV2.business) === null || _e === void 0 ? void 0 : _e.importAnalytics)) && (_jsx(GiFairyWand, { style: {
                                                    color: "#ff877b",
                                                    verticalAlign: "top",
                                                    display: "inline-block",
                                                    fontSize: "1.5em",
                                                    marginRight: "0.5em",
                                                } })), "We've used your store data to generate 3 membership tiers for your customers! They're optimized for growth using our ", _jsx("a", { target: "_blank", href: "https://why.withfriends.co/posts/memberships/#pricing-your-memberships-the-20-70-140-rule", children: "20-70-140 rule" }), ".", _jsx("br", {}), _jsx("br", {}), "Customize anything you'd like below.", currentShopifyVersion == 2 && ("  For advanced features, navigate to Advanced Options.")] })), _jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("br", {}), _jsxs("span", { children: ["When you're ready, click ", _jsx("strong", { children: "Continue to Brand" }), " at the bottom."] })] })] }) }) })), _jsx("div", { className: "sm:flex sm:flex-wrap sm:justify-center sm:justify-items-center w-full mt-8", style: { width: "102%" }, children: data.business.membershipTiers &&
                            data.business.membershipTiers.map((tier, i) => {
                                var _a, _b;
                                return (_jsx(MembershipLevel, { position: i == 0
                                        ?
                                            MembershipLevelPosition.Low
                                        :
                                            i == data.business.membershipTiers.length - 1
                                                ?
                                                    MembershipLevelPosition.High
                                                :
                                                    i == 1
                                                        ?
                                                            MembershipLevelPosition.Middle
                                                        :
                                                            null, id: tier.id, extraButtons: extraButtons, collections: collections, strategyPrice: (_a = newTiers[i]) === null || _a === void 0 ? void 0 : _a.price, strategyDiscount: (_b = newTiers[i]) === null || _b === void 0 ? void 0 : _b.discount, useSyncShopifyDataMutation: useSyncShopifyDataMutation, suppressDelete: data.business.membershipTiers.length == 1 }, tier.id));
                            }) }), currentShopifyVersion == 2 && (_jsx("div", { className: "mb-4 max-w-xl w-full mx-auto", children: _jsx(Button, { variant: ButtonVariant.Outlined, onClick: () => {
                                // mixpanel.track(PrimaryAction, { action: ChooseYourFighterAction.AddedMembershipLevel })
                                primaryActionLoadingVar(true);
                                addTier();
                            }, disabled: primaryActionLoading, children: "+ Add Tier" }) }))] })] }));
};
export default ChooseYourFighter;
